// axios
import axios from 'axios'
//const domain = "http://apitest.test/gestor/";
const domain = "https://api2.wedocare.com.br/";
// const domain = "http://localhost/";
const token = localStorage.getItem("accessToken");
export default axios.create({
  baseURL: domain,
  headers: token?{ Authorization: `Bearer ${token}` }:null
  // You can add your headers here
})
